<script >
import {defineComponent} from 'vue'
import {resetDataUpload} from "@/api/openNew";

export default defineComponent({
  name: "DataUploadedModal",
  data() {
    return {
      visible: false,
      confirmLoading: false,
      programId:""
    };
  },
  methods: {

    async handleBtnEditClick(){
      const res = await resetDataUpload({
        programId: this.programId
      })
      if (res.code==200){
        this.$emit("unlock",res.data)
      }

    },
    close() {
      this.visible = false;
    },
    open(programId) {
      this.visible = true;
      this.programId = programId
    }
  },
})
</script>

<template>
  <div>
    <a-modal
      :maskStyle="{top:'50px'}"
      wrapClassName="the-modal"
      title="Title"
      :width="370"
      :visible="visible"
      :confirm-loading="confirmLoading"
      :mask="true"
      :closable="false"
      :maskClosable="false"
      :centered="true"
      :footer="null"
    >
      <div>
        <img src="@/assets/need-upload.svg" alt="" style="width: 160px; height: 136px; display: block; margin: 16px auto 40px;" class=""/>
        <div class="text">您已上传数据，如需修改请点击编辑</div>
        <div class="btn-wrapper">
          <button class="btn-default btn-edit" @click="handleBtnEditClick">编辑</button>
        </div>

      </div>
    </a-modal>
  </div>


</template>

<style scoped lang="stylus">
.bg-masker{
  position absolute;
  background-color: rgba(0, 0, 0, 0.45);
  top 0;
  left 0;
  bottom 0;
  right 0;
  z-index 1000;
}
:deep(.the-modal){

  .ant-modal-content{
    border-radius 8px
    }
  .ant-modal-header{
    display none
  }
  top:70px
}
.text{
  color: #1D2129;
  font-weight: 400;
  font-size: 16px;
  text-align: center;
}
.btn-wrapper{
  margin-top 20px
  margin-bottom 16px
  .btn-edit{
    display block
    width 124px
    height 32px;
    margin 0 auto
  }
}

</style>
